import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { CommandController } from '../../../core/component/base/command-controller.base';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { Command, CommandBase } from '../../../core/model/command';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { RentalObjectImprovement } from '../../model/rental-object-improvement';

@Component({
    selector: 'app-rental-object-improvements',
    templateUrl: './rental-object-improvements.component.html',
    styleUrls: ['./rental-object-improvements.component.scss'],
    providers: [CommandDispatcher],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentalObjectImprovementsComponent extends CommandController implements OnInit {
  constructor(
    handlerResolver: CommandHandlerResolver,
    columnDefinitionFactory: ColumnDefinitionFactory,
    commandDispatcher: CommandDispatcher
  ) {
    super(commandDispatcher, handlerResolver);
    this.columnDefinition = [
      columnDefinitionFactory.create('RENTAL_OBJECT_IMPROVEMENTS.PERFORM_YEAR', 'performYear'),
      columnDefinitionFactory.createTranslation('RENTAL_OBJECT_IMPROVEMENTS.PERFORM_MONTH', 'performMonthCaption'),
      columnDefinitionFactory.create('RENTAL_OBJECT_IMPROVEMENTS.DESCRIPTION', 'description'),
      columnDefinitionFactory.create('RENTAL_OBJECT_IMPROVEMENTS.INTERVAL', 'interval'),
      columnDefinitionFactory.create('RENTAL_OBJECT_IMPROVEMENTS.STOP_YEAR', 'stopYear'),
      columnDefinitionFactory.createMoney('RENTAL_OBJECT_IMPROVEMENTS.COST', 'cost'),
    ];
    this.menuDefinition = [
      new MenuItemDefinition('EDIT_BTN', 'editImprovementRow'),
      new MenuItemDefinition('DELETE_BTN', 'deleteImprovementRow'),
    ];
  }

  @Input() form: AbstractControl;
  @Input() itemsSource: RentalObjectImprovement[];
  @Input() currencyCode: string;

  private _isNew: boolean;
  columnDefinition: ColumnDefinition[];
  menuDefinition: MenuItemDefinition[] = [];
  selectedRow: RentalObjectImprovement;

  private _deleteItem(row: RentalObjectImprovement) {
    let index = this.itemsSource.indexOf(row);
    if (index > -1) {
      this.itemsSource.splice(index, 1);
      if (this.form.pristine) this.form.markAsDirty();
    }
  }

  private _editItem(row: RentalObjectImprovement) {
    this.selectedRow = this.itemsSource.find(x => x === row);
  }

  canExecute(command: CommandBase): boolean {
    switch (command.id) {
      case 'editImprovementRow':
      case 'deleteImprovementRow':
        return true;

      default:
        return false;
    }
  }

  execute(command: CommandBase): void {
    switch (command.id) {
      case 'deleteImprovementRow':
        this._deleteItem((<Command>command).context);
        break;

      case 'editImprovementRow':
        this._editItem((<Command>command).context);
        break;
    }
  }

  createItem() {
    let row = new RentalObjectImprovement(this.currencyCode);
    this.itemsSource.push(row);
    this.selectedRow = row;
    this._isNew = true;
  }

  ngOnInit() {}

  onCompleted(applyChanges: boolean) {
    if (!applyChanges && this._isNew) {
      this._deleteItem(this.selectedRow);
    }
    if (applyChanges && this.form.pristine) {
      this.form.markAsDirty();
    }
    this.selectedRow = null;
    this._isNew = false;
  }

  onRowClicked(e: { context: RentalObjectImprovement; event: any }) {
    this._editItem(e.context);
  }
}
